<template>
 <Teleport
   to="body"
   v-if="useNotify.show"
 >
  <div class="fixed z-50 flex items-center justify-center w-screen animate-slide-up bottom-20">
   <div
     :class="colorClass[useNotify.type]"
     class="inline-flex items-center justify-center px-12 py-2 text-white w-fit rounded-7"
   >{{
    useNotify.message }}</div>
  </div>
 </Teleport>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

const store = useStore()

const colorClass = {
 'error': 'bg-slate-800',
 'success': 'bg-green-500'
}

const useNotify = computed(() => {
 return store.getters.notify
})

</script>
